import apiServices from 'config/apiServiceApiGateway'
import {
  type XdockTaskStatusType,
  type XDockTaskInterface,
  type XdockTaskTypeType,
  type XdockTaskStaffInterface,
  type XdockTaskDetailInterface,
  type XdockTaskLabelInterface,
  type SupplyOrderPoolingDetailInterface,
  type SOPoolDetailInterface,
  type SOPoolDetailDTCLabelInterface,
} from 'features/SupplyOrder/@types/XDock'
import { buildQueryParams } from 'utils/helpers/queryParams'
import { NextProcessType } from '../pages/XdockV2/@types'

const { Get, Post } = apiServices

export type GetXdockTaskListParamsType = {
  page_index: number
  page_size: number
  type: XdockTaskTypeType
  product?: string // search by product name or SKU
  po_number?: string // search by po number
  inbound_date?: string // Filter by inbound date in `YYYY-MM-DD` format
  statuses?: XdockTaskStatusType
  location_ids?: number[] // multiple location IDs; serialized as CSV (e.g. "1642,1622") below
  wave_numbers?: number
  staff_ids?: number
}

export const getXdockTaskListApi = (params: GetXdockTaskListParamsType) =>
  Get<XDockTaskInterface[]>({
    url: '/wims/internal/:version/xdock-tasks',
    version: 'v2',
    params,
    config: {
      paramsSerializer: {
        serialize: (query) => buildQueryParams(query).toString(),
      },
    },
  })

export type GetSupplyOrderPoolDetailListParamsType = {
  page_index: number
  page_size: number
  is_dtc: boolean
  search_product_name?: string
  search_po_number?: string
}

export const getSupplyOrderPoolDetailListApi = (params: GetSupplyOrderPoolDetailListParamsType) =>
  Get<SOPoolDetailInterface[]>({
    url: '/wims/internal/v1/supply-order-pool-details',
    params,
  })

export const getXdockTaskDetailApi = (xdockTaskId: number) =>
  Get<XdockTaskDetailInterface>({
    url: `/wims/internal/v1/xdock-tasks/${xdockTaskId}`,
  })

export type GetXdockTaskLabelParamsType = {
  supply_order_pool_id: number
}

export const getXdockTaskLabelApi = (xdockTaskId: number, params: GetXdockTaskLabelParamsType) =>
  Get<XdockTaskLabelInterface>({
    url: `/wims/internal/v1/xdock-tasks/${xdockTaskId}/labels`,
    params,
  })

export const getSOPoolDetailDTCLabelApi = (poolId: number | string) =>
  Get<SOPoolDetailDTCLabelInterface[]>({
    url: `/wims/internal/v1/supply-order-pool-details/pools/${poolId}/labels`,
  })

export const postCompletePoolingApi = (poolingId: number, body: { type: NextProcessType }) =>
  Post({
    url: `/wims/internal/v1/supply-order-pools/${poolingId}:complete`,
    data: body,
  })

export const getLatestSupplyOrderPooling = (params: { location_id: number }) =>
  Get<SupplyOrderPoolingDetailInterface>({
    url: '/wims/internal/v1/supply-order-pools/latest',
    params,
  })

export type GetXdockTaskStaffListParamsType = {
  location_id?: number
  name?: string
  page_size?: number
  page_index?: number
}

export const getXdockTaskStaffListApi = (params: GetXdockTaskStaffListParamsType) =>
  Get<XdockTaskStaffInterface[]>({
    url: '/wims/internal/v1/xdock-tasks:staffs',
    params,
  })

export type PostAssignXdockTaskBodyType = {
  waves: {
    wave_number?: number
    staff_id: number
  }[]
}

export const postAssignXdockTaskApi = (xdockTaskId: number, body: PostAssignXdockTaskBodyType) =>
  Post({
    url: `/wims/internal/v2/xdock-tasks/${xdockTaskId}:assign`,
    data: body,
  })
